import { ExclamationCircleIcon, ShieldCheckIcon } from '@heroicons/react/24/outline'
import RouteKeys from 'constants/route-keys'
import { RouteElement } from 'interfaces/_common'
import React, { Suspense } from 'react'
import { SubMenuTabs } from '../common'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PagePreloader } from 'components/pagePreloader'
import PaymentMethod from './PaymentMethod'
import PaymentErrorConfig from './PaymentErrorConfig'

const _routes: RouteElement[] = [
  {
    route: 'payment-method',
    title: 'Payment Method',
    key: RouteKeys.CUSTOM_CHECKOUT,
    component: PaymentMethod,
    icon: ShieldCheckIcon,
    display: true
  },
  {
    route: 'payment-error',
    title: 'Payment Error',
    key: RouteKeys.CUSTOM_CHECKOUT,
    component: PaymentErrorConfig,
    icon: ExclamationCircleIcon,
    display: true
  }
]

const CustomCheckout = () => {
  return (
    <div>
      <SubMenuTabs _routes={_routes} />
      <div className="p-3">
        <Routes>
          <Route 
            path='' 
            element={<Navigate to={_routes[0].route} replace />} 
          />
          {_routes.map(route => {
            const ReportComponent = route.component

            return (
              <Route
                path={route.route}
                key={'report-' + route.route}
                element={
                  <Suspense fallback={<PagePreloader />}>
                    <ReportComponent />
                  </Suspense>
                }
              />
            )
          })}
          <Route path="user-plan-report" element={<Navigate to="custom-checkout" replace />} />
        </Routes>
      </div>
    </div>
  )
}

export default CustomCheckout
